import axios from 'axios';
import config from './config';
import {
  util,
  lg
} from 'utils';

let base = util.getDomain();


//登录退出
export const requestLogin = params => {
  return axios.get(`${base}/api/Admin/Login`, {
    params: params
  });
};
export const requestLogout = params => {
  return axios.get(`${base}/api/Admin/Logout`, {
    params: params
  });
};

//获取角色列表
export const GetRoleList = params => {
  return axios.get(`${base}/api/Admin/GetRoleList`, {
    params: params
  });
};
//角色id查询
export const GetEmployByRoleId = params => {
  return axios.get(`${base}/api/Admin/GetEmployByRoleId`, {
    params: params
  });
};

//更新包含人员
export const UpdateRoleEmploy = params => {
  return axios.post(`${base}/api/Admin/UpdateRoleEmploy`, params, config);
};

//删除人员
export const DelRole = params => {
  return axios.post(`${base}/api/Admin/DelRole`, params, config);
};

//新增根据角色ID查询该角色名和权限列表
export const GetRoleMenuByRoleId = params => {
  return axios.get(`${base}/api/Admin/GetRoleMenuByRoleId`, {
    params: params
  });
};

//增加角色
export const AddRole = params => {
  return axios.post(`${base}/api/Admin/AddRole`, params, config);
};
//更新角色
export const UpdateRole = params => {
  return axios.post(`${base}/api/Admin/UpdateRole`, params, config);
};


// WEBPACK FOOTER //
// ./src/api/adminApi.js